import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  strategicPillarsLength: 0,
  strategicPillars: [],
  strategicPillar: {},
  strategicPillarError: "",
  formError: "",
};

export default function StrategicPillarReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_STRATEGIC_PILLAR:
      return { ...state, loading: action.payload };
    case actions.LOADING_STRATEGIC_PILLAR_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_STRATEGIC_PILLAR:
      return { ...state, saveLoading: action.payload };
    case actions.GET_STRATEGIC_PILLAR:
      return {
        ...state,
        strategicPillars: action.payload.strategicPillars,
        strategicPillarsLength: action.payload.strategicPillarsLength,
      };
    case actions.GET_STRATEGIC_PILLAR_BY_ID:
      return {
        ...state, strategicPillar: action.payload
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.STRATEGIC_PILLAR_FAIL:
      return { ...state, strategicPillarError: action.payload };
    default:
      return state;
  }
}
